import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.prototype.$http = axios
Vue.use(Vuex)
const state = {
  cusid: '',
  sptypes: [],
  sptypeobj: '',
  spobjs: [],
  queryspobj: '',
  spobj: '',
  articles: [],
  queryarticleobj: '',
  articleobj: '',
  addstate: false,
  delstate: false,
  querybaseobj: '',
  baseobj: '',
  baseobjs: []
}
// 唯一改变状态的地方，类似于事件，每个mutations都有一个类型 type 和一个回调函数 handler
const mutations = {
  // 设置客户ID
  setcusid (state, payload) {
    state.cusid = payload.cusid
  },
  // 保存专题分类
  setsptypes (state, res) {
    state.sptypes = res
  },
  // 设置查询专题分类的参数
  setsptypeobj (state, payload) {
    state.sptypeobj = payload.sptypeobj
  },
  // 设置添加数据是否成功的状态
  setaddstate (state, res) {
    // 更新状态
    state.addstate = res
  },
  // 设置删除数据是否成功的状态
  setdelstate (state, res) {
    state.delstate = res
  },
  // 保存专题列表
  setspobjs (state, res) {
    state.spobjs = res
  },
  // 设置查询专题分类的参数
  setqueryspobj (state, payload) {
    state.queryspobj = payload.queryspobj
  },
  // 设置查询专题分类的参数
  setspobj (state, payload) {
    state.spobj = payload.spobj
  },
  // 保存文章列表
  setarticles (state, res) {
    state.articles = res
  },
  // 设置查询文章的参数
  setqueryarticleobj (state, payload) {
    state.queryarticleobj = payload.queryarticleobj
  },
  // 设置查询文章的参数
  setarticleobj (state, payload) {
    state.articleobj = payload.articleobj
  },
  // 设置查询网站的参数
  setquerybaseobj (state, payload) {
    state.querybaseobj = payload.querybaseobj
  },
  // 设置网站的参数
  setbaseobj (state, payload) {
    state.baseobj = payload.baseobj
  },
  // 保存返回的网站参数
  setbaseobjs (state, res) {
    state.baseobjs = res
  }
}
// 只负责行为，提交给mutations进行状态变更，用来处理逻辑
const actions = {
  // 获取专题分类列表
  async getsptypes ({ commit, state }, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/qst',
      method: 'post',
      data: {
        whereinfo: {String: 'cusid =' + state.cusid, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          console.log(JSON.parse(res.data.data))
          commit('setsptypes', JSON.parse(res.data.data))
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 添加专题分类
  async addsptypes ({ dispatch, commit }, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/aausp',
      method: 'post',
      data: state.sptypeobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          dispatch('getsptypes')
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 删除专题分类
  async delsptypes ({ dispatch, commit }, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/dsp',
      method: 'post',
      data: state.sptypeobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          dispatch('getsptypes')
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 获取专题列表
  async getsplist ({commit, state}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/qsi',
      method: 'post',
      data: state.queryspobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          if (res.data.success) {
            commit('setspobjs', JSON.parse(res.data.data))
            payload.success()
          } else {
          }
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 添加专题
  addsp ({dispatch, commit}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/aausi',
      method: 'post',
      data: state.spobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          dispatch('getsplist')
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 删除专题
  delsp ({dispatch, commit}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/dsi',
      method: 'post',
      data: state.spobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          dispatch('getsplist')
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 获取文章列表
  getarticlelist ({commit, state}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/qai',
      method: 'post',
      data: state.queryarticleobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          if (res.data.success) {
            commit('setarticles', JSON.parse(res.data.data))
            payload.success()
          } else {
          }
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 添加文章
  addarticle ({dispatch, commit}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/aauai',
      method: 'post',
      data: state.articleobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          dispatch('getarticlelist')
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 删除文章
  delarticle ({dispatch, commit}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/dai',
      method: 'post',
      data: state.articleobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          dispatch('getarticlelist')
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 查询网站信息
  querywebsite ({commit, state}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/qbi',
      method: 'post',
      data: state.querybaseobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          if (res.data.success) {
            commit('setbaseobjs', JSON.parse(res.data.data))
            payload.success()
          } else {
          }
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 添加文章
  savewebsite ({dispatch, commit}, payload) {
    axios({
      url: 'https://api.sqnetsoft.cn/website/aaubi',
      method: 'post',
      data: state.baseobj,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          dispatch('querywebsite')
          payload.success()
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  }
}
// 用于过滤可选范围，细分子状态的值
const getters = {

}

export default ({
  namespaced: true,
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/website.js